import React from 'react';
import LocationHelper from '../../helpers/location_helper';

// import Stips from "./stips";

const SigningComplete = () => {
  let { event, recipientId, envelopeId, signerEmail, signerName, proposalId, token, signerRole } =
    LocationHelper.searchAsObj();

  if (event === 'id_check_failed') {
    window.location.href = `${LocationHelper.getUrlForSubdomain(
      'switch'
    )}/kba-fail?token=${token}&recipientId=${recipientId}&envelopeId=${envelopeId}&signerEmail=${signerEmail}&signerName=${signerName}&signerRole=${signerRole}&proposalId=${
      proposalId || null
    }`;
    return <div>Redirecting...</div>;
  }

  //    would strip kba, but tools doesn't permit it because
  //    the envelope status was not 'created', 'sent' or 'delivered'
  // useEffect(() => {
  //   if (event === 'signing_complete') {
  //     FetchHelper.fetchJson(
  //       `document-envelopes/${token ? `${token}/` : ''}kba?envelopeId=${envelopeId}&signerEmail=${encodeURIComponent(
  //         signerEmail
  //       )}&signerName=${signerName}&signerRole=${signerRole}&proposalId=${proposalId}&recipientId=${recipientId}`,
  //       { method: 'delete' }
  //     );
  //   }
  // }, []);

  // setTimeout(() => {
  //   new confetti().startConfetti();
  // }, 500);

  return (
    // <canvas id={'confetti-canvas'} style={{
    //   left : '0px',
    //   top : '0px',
    //   width : '100%',
    //   height : '100%',
    //   position: 'absolute', zIndex: -1, pointerEvents:'none'
    // }}>
    // </canvas>
    // <h1>
    //   w00t! *confetti*
    // </h1>
    <div className="card-page" id="qa-docusign-email-complete">
      <div className="card secondary-page smaller">
        <h1 className="title blue">
          Signing is complete!
          <br /> You may now close this window.
        </h1>
      </div>
    </div>
    // <h3 className={'qa-docusign-email-complete'}>Signing is complete, you may now close this window</h3>
    // <Stips
    //   displayOnNoStips={<h3 className={"qa-docusign-email-complete"}>Signing is complete, {'you may now close this window' }</h3>}
    //   additionalTitle={<h3 className={"qa-docusign-email-complete-but-need-stips"}>You've completed signing your document(s), but we need additional information.</h3>}
    // />
  );
};

export default SigningComplete;
